import { render, staticRenderFns } from "./ScreenCatalogue.vue?vue&type=template&id=405ef7e2&scoped=true&lang=pug"
import script from "./ScreenCatalogue.vue?vue&type=script&lang=ts"
export * from "./ScreenCatalogue.vue?vue&type=script&lang=ts"
import style0 from "./ScreenCatalogue.vue?vue&type=style&index=0&id=405ef7e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405ef7e2",
  null
  
)

export default component.exports